import { ItemSortOption } from '@rematter/frontend-lib-api-client';
import groupBy from 'lodash/groupBy';
import keyBy from 'lodash/keyBy';

import { InventoryItemRecord } from '../types/load';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const inventoryItemsQueryAtom = createQueryAtomFactory(
  'trade.inventoryItems',
  (params: {
    searchTerm?: string;
    sorting?: ItemSortOption[];
    limit?: number;
    offset?: number;
  }) => ({
    items: {
      __args: {
        filter: params.searchTerm
          ? {
              searchTerm: params.searchTerm,
            }
          : undefined,
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 10,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
        skuNumber: true,
        effectivePricingUnit: true,
        category: {
          id: true,
          name: true,
          attributes: true,
        },
        attributeValues: true,
        colorHue: true,
        itemGroup: {
          id: true,
          name: true,
          number: true,
          colorHue: true,
        },
      },
    },
  }),
  {
    select: (data) => {
      const allItems: InventoryItemRecord[] =
        data?.items.entries.map((item) => ({
          id: item.id,
          name: item.name,
          mnemonic: item.skuNumber,
          colorHue: item.colorHue,
          effectivePricingUnit: item.effectivePricingUnit,
          categoryId: item.category?.id,
          itemGroupId: item.itemGroup?.id,
          itemGroup: item.itemGroup
            ? {
                id: item.itemGroup.id,
                name: item.itemGroup.name,
                number: item.itemGroup.number ?? undefined,
                colorHue: item.itemGroup.colorHue,
              }
            : undefined,
          category: item.category
            ? {
                name: item.category.name,
              }
            : undefined,
          metadata: item,
        })) ?? [];

      const itemsById = keyBy(allItems, (it) => it.id);

      // Filter out items without valid itemGroup before grouping
      const itemsWithGroup = allItems.filter(
        (it) => it.itemGroup?.id && it.itemGroup?.name,
      );
      const itemsByGroup = groupBy(itemsWithGroup, (it) => it.itemGroup?.id);
      const itemGroups = Object.values(itemsByGroup).map(
        (it) => it[0].itemGroup,
      );

      return { allItems, itemsById, itemsByGroup, itemGroups };
    },
  },
);
